import { render, staticRenderFns } from "./HelpCenterLogin.vue?vue&type=template&id=2b780df9&scoped=true"
import script from "./HelpCenterLogin.vue?vue&type=script&lang=js"
export * from "./HelpCenterLogin.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterLogin.vue?vue&type=style&index=0&id=2b780df9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b780df9",
  null
  
)

export default component.exports